import axios from 'axios';
import { useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, ProgressBar, Spinner } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import COS from 'cos-js-sdk-v5';
import {toggleLogin, toggleRole} from '../actions/index';
import SiteNav from '../components/SiteNav';
import FileTable from '../components/FileTable';
import AddFileImage from '../components/AddFileImage';
import { addTokenHeader, logout, formatBytes } from '../utils';

const DisplayItemsTable = (props) => {
    const SECRET_ID = process.env.REACT_APP_SECRET_ID;
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
    const BUCKET = process.env.REACT_APP_BUCKET;
    const REGION = process.env.REACT_APP_REGION;
    
    let id = props.location.pathname.substring(1);
    let history = useHistory();
    const { role } = props;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [uploadingStatus, setUploadingStatus] = useState(null);
    const [files, setFiles] = useState(false);
    const [fileIndex, setFileIndex] = useState(0);
    const [folder, setFolder] = useState(false);
    const [folderName, setFolderName] = useState(null);
    const [project, setProject] = useState(false);
    const [projectName, setProjectName] = useState(null);
    const [show, setShow] = useState(false);
    const [currentPath, setCurrentPath] = useState();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        getFiles();
    }, [])

    const getFiles = () => {
        setLoading(true);
        const payload = {
            id
        }
        setCurrentPath(id.split("/"))
        axios.post('/api/files', payload, addTokenHeader())
            .then(res => {
                let thisLevelItems = [];
                for (var i=0; i<res.data.length; i++) {
                    const thisLevelItemName = res.data[i]['Key'].split("/")[0];
                    let fileType;
                    if (res.data[i]['Key'].split("/").length > 1) {
                        fileType = 'FOLDER';
                    }
                    else {
                        fileType = 'FILE';
                    }
                    thisLevelItems.push(
                        {
                            'name': thisLevelItemName, 
                            'type': fileType, 
                            'size': res.data[i].Size, 
                            'modified': res.data[i].LastModified,
                            'downloadPermission': res.data[i].downloadPermission,
                            'editPermission': res.data[i].editPermission,
                            'pdfViewPermission': res.data[i].pdfViewPermission,
                            'deletePermission': res.data[i].deletePermission
                        }
                    );
                }
                const result = []
                const map = new Map();
                for (const item of thisLevelItems) {
                    if (!map.has(item.name)){
                        map.set(item.name, true);
                        result.push({
                            name: item.name,
                            type: item.type,
                            size: item.size,
                            modified: item.modified,
                            downloadPermission: item.downloadPermission,
                            editPermission: item.editPermission,
                            pdfViewPermission: item.pdfViewPermission,
                            deletePermission: item.deletePermission
                        })
                    }
                }
                result.sort((a, b) => (a.name < b.name) ? 1 : -1)
                result.sort((a, b) => (a.type < b.type) ? 1 : -1)
                setData(result);
                setLoading(false);
                props.toggleLogin(true);
            })
            .catch(error => {
                if (error.response.status === 401 || error.response.status === 400) {
                    logout();
                    props.toggleLogin(false);
                    props.toggleRole(null);
                    history.push("/login");
                }
                else {
                    setLoading(false);
                    window.alert(error.response.data.msg);
                }
            })
    }

    async function uploadFile() {
        setUploading(true);
        await sendDataPromise(0);
        window.location.reload(false);
    }

    function sendDataPromise(index) {
        return new Promise((resolve) => {
            setFileIndex(index);
            let uploadFilepath;
            if (id) {
                uploadFilepath = `${id}/${files[index].name}`
            }
            else {
                uploadFilepath = files[index].name
            }
            let isAlreadyInData = false;
            for (var i=0; i<data.length; i++) {
                if (files[index].name.trim() === data[i].name.trim()) {
                    isAlreadyInData = true;
                }
            }
            if (isAlreadyInData) {
                window.alert(`已有文件利用这个名字: ${files[index].name}`);
                if (index + 1 < files.length) {
                    return resolve(sendDataPromise(index + 1));
                }
                else {
                    return resolve();
                }
            }
            else if (files) {
                var cos = new COS({
                    SecretId: SECRET_ID,
                    SecretKey: SECRET_KEY
                });
                cos.sliceUploadFile({
                    Bucket: BUCKET,
                    Region: REGION,
                    Key: uploadFilepath,
                    Body: files[index],
                    TaskReady: function(taskId) { /*Optional*/
                        console.log(taskId);
                    },
                    onHashProgress: function (progressData) { /* Optional */
                        console.log(JSON.stringify(progressData));
                    },
                    onProgress: function (progressData) { /* Optional */
                        console.log(JSON.stringify(progressData));
                        setUploadingStatus(progressData.percent * 100);
                    }
                }, function(err, data) {
                    console.log(err || data);
                    if (!err) {
                        const payload = {
                            entityname: uploadFilepath,
                            entitytype: 'FILE',
                            entityaction: 'UPLOAD',
                            entitylocation: '项目'
                        }
                        axios.post('/api/files/manager/update', payload, addTokenHeader())
                        .then(res => {
                            if (index + 1 < files.length) {
                                return resolve(sendDataPromise(index + 1));
                            }
                            else {
                                return resolve(res);
                            }
                        }).catch(err => {
                            window.alert(err);
                            if (index + 1 < files.length) {
                                return resolve(sendDataPromise(index + 1));
                            }
                            else {
                                return resolve(err);
                            }
                        });
                    }
                    else {
                        // window.location.reload(false);
                    }
                });
            }
        })
    }

    const uploadProject = () => {
        const payload = {
            projectName
        }

        if (projectName) {
            axios.post('/api/files/project/add', payload, addTokenHeader())
            .then(res => {
                const payload = {
                    entityname: projectName,
                    entitytype: 'FOLDER',
                    entityaction: 'UPLOAD',
                    entitylocation: '项目'
                }
                axios.post('/api/files/manager/update', payload, addTokenHeader())
                .then(res => {
                    window.location.reload(false);
                }).catch(err => {
                    window.location.reload(false);
                });
            }).catch(error => {
                if (error.response.status === 400 || error.response.status === 401) {
                    logout();
                    props.toggleLogin(false);
                    props.toggleRole(null);
                    history.push('/login');
                }
                else {
                    window.alert(error.response.data.msg);
                }
            });
        }
    }

    const handleUpload = (event) => {
        const uploadFiles = event.target.files;
        setFiles(uploadFiles);
        setFolder(false);
        setProject(false);
    }

    const setViewFolderInput = () => {
        setFiles(false);
        setFolder(true);
        setProject(false);
    }

    const setViewProjectInput = () => {
        setFiles(false);
        setProject(true);
        setFolder(false);
    }

    const handleOnFolderNameUpdate = (e) => {
        e.preventDefault();
        setFolderName(e.target.value);
    }

    const handleOnProjectNameUpdate = (e) => {
        e.preventDefault();
        setProjectName(e.target.value);
    }

    const uploadFolder = () => {
        let uploadFolderPath;
        if (id) {
            uploadFolderPath = `${id}/${folderName}/`
        }
        else {
            uploadFolderPath = `${folderName}/`
        }
        let isAlreadyInData = false;
        for (var i=0; i<data.length; i++) {
            if (folderName.trim() === data[i].name.trim()) {
                isAlreadyInData = true;
            }
        }
        if (isAlreadyInData) {
            window.alert("已有文件夹利用这个名字");
        }
        else if (folderName) {
            var cos = new COS({
                SecretId: SECRET_ID,
                SecretKey: SECRET_KEY
            });
            cos.putObject({
                Bucket: BUCKET,
                Region: REGION,
                Key: uploadFolderPath,
                StorageClass: 'STANDARD',
                Body: '',
                onProgress: function(progressData) {
                    console.log(JSON.stringify(progressData));
                }
            }, function(err, data) {
                console.log(err || data);
                if (!err) {
                    const payload = {
                        entityname: uploadFolderPath,
                        entitytype: 'FOLDER',
                        entityaction: 'UPLOAD',
                        entitylocation: '项目'
                    }
                    axios.post('/api/files/manager/update', payload, addTokenHeader())
                    .then(res => {
                        window.location.reload(false);
                    }).catch(err => {
                        window.location.reload(false);
                    });
                }
                else {
                    window.location.reload(false);
                }
            });
        }
    }

    return (
        <div>
            <SiteNav />
            <div className="container" style={{paddingTop: 50, paddingBottom: 50}}>
                {
                    !loading && data ?
                    <>
                        <AddFileImage handleShow={handleShow} />
                        <div className="text-center">
                            {
                                id ?
                                <span><a href="/"> 项目 </a> /</span> :
                                <span> 项目 </span>
                            }
                            {
                                currentPath.map((route, ind) => {
                                    return (
                                        <span key={ind}>
                                            {
                                                ind === currentPath.length-1 ?
                                                <span> {route} </span> :
                                                <span><a href={`/${currentPath.filter((item, itemIndex) => itemIndex <= ind).join('/')}`}> {route} </a> /</span>
                                            }
                                        </span>
                                    )
                                })
                            }
                        </div>
                    </>:
                    <Spinner style={{marginLeft: "50%", marginRight: "50%"}} animation="grow"/>
                }
                {
                    !loading && data &&
                    <FileTable 
                        data={data} 
                        id={id} 
                        role={role} 
                        bucket={BUCKET} 
                        deleteEndpoint='/api/files/delete' 
                        entitylocation='项目'
                        rootpath="/" 
                    />
                }
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>上传</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="input-container">
                            {
                                role === 'SUPER' &&
                                <div className="button-wrap">
                                    <div className="button" 
                                        style={{
                                            margin: 5, 
                                            pointerEvents: uploading ? true && 'none' : 'auto',

                                            opacity: uploading ? true && 0.65 : 1

                                        }} 
                                        onClick={setViewProjectInput}
                                    >
                                        项目
                                    </div>
                                </div>
                            }
                            <div className="button-wrap">
                                <div className="button" 
                                    style={{
                                        margin: 5,
                                        pointerEvents: uploading ? true && 'none' : 'auto',
                                        opacity: uploading ? true && 0.65 : 1
                                    }} 
                                    onClick={setViewFolderInput}
                                >
                                    文件夹
                                </div>
                            </div>
                            <div className="button-wrap">
                                <label className="button" style={{
                                        margin: 5,
                                        pointerEvents: uploading ? true && 'none' : 'auto',
                                        opacity: uploading ? true && 0.65 : 1
                                    }} 
                                    htmlFor="upload" 
                                >
                                    文件
                                </label>
                                <input id="upload" type="file" multiple style={{width: 10}} onChange={handleUpload} />
                            </div>
                        </div>
                        {
                            files &&
                            <div className="text-center" style={{marginTop: 10}}>
                                <p>文件名：{files[fileIndex].name}</p>
                                <p>文件大小：{formatBytes(Number(files[fileIndex].size))}</p>
                                <Button variant="info" onClick={uploadFile} disabled={uploading ? true : false}>上传</Button>
                                {
                                    uploadingStatus &&
                                    <div style={{marginTop: 10}}>
                                        <p>上传进度</p>
                                        <ProgressBar animated now={uploadingStatus} />
                                    </div>
                                }
                            </div>
                        }
                        {
                            folder &&
                            <div className="text-center" >
                                <Form>
                                    <Form.Group controlId="exampleForm.ControlInput1">
                                        <Form.Control type="text" placeholder="文件夹名" onChange={handleOnFolderNameUpdate} />
                                    </Form.Group>
                                </Form>
                                <Button variant="info" onClick={uploadFolder} disabled={uploading ? true : false}>上传</Button>
                            </div>
                        }
                        {
                            project &&
                            <div className="text-center" >
                                <Form>
                                    <Form.Group controlId="exampleForm.ControlInput2">
                                        <Form.Control type="text" placeholder="项目名" onChange={handleOnProjectNameUpdate} />
                                    </Form.Group>
                                </Form>
                                <Button variant="info" onClick={uploadProject} disabled={uploading ? true : false}>上传</Button>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={uploading ? true : false}>
                        取消
                    </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        isLoggedIn: state.isLoggedIn,
        role: state.role
    };
}
  
function matchDispatchToProps(dispatch){
    return bindActionCreators({toggleLogin: toggleLogin, toggleRole: toggleRole}, dispatch);
}
  
export default connect(mapStateToProps, matchDispatchToProps)(DisplayItemsTable);